import React, { useEffect, useState } from "react";
import { PayoutSentToQc } from "./PayoutSentToQc";
import { useDispatch, useSelector } from "react-redux";
import { TotalProveiderMonth, formattedDate } from "./helper";
import { GetAppointmentPayoutDetailsNetworkAction } from "../../../redux/actions/PayoutAction";
import CustomPagination from "../../../common/CustomPagination";
import { payOutHeaderValue } from "./AdditionalApptHeader";
import moment from "moment";

export const UnsuccessfulAppointment = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  header,
  setSelectAllFlag,
  setSelectAll,
  showData,
  setShowData,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const [tableIndex, setTableIndex] = useState(null);

  useEffect(() => {
    dispatch(
      GetAppointmentPayoutDetailsNetworkAction({
        ...searchFilter,
        IsPayoutStatus: false,
        page: 1,
      })
    );
  }, []);
  console.log(header)
  return (
    <>
      
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr className="avanishtbl">
                <th>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={
                      payoutReducer?.getTotalAppointmentPayout?.length ===
                      providerDetail?.length
                    }
                    onClick={(e) => {
                      if (e.target.checked) {
                        setProviderDetail(
                          payoutReducer?.getTotalAppointmentPayout
                        );
                        setSelectAllFlag(true);
                      } else {
                        setSelectAll(false);
                        setProviderDetail([]);
                        setSelectAllFlag(false);
                      }
                    }}
                    readOnly
                  />
                </th>
                {searchFilter?.BusinessType === "CBU" && (
                  <>
                    <th className="payOutAdditionalTest">Provider Name</th>
                    <th>Client Name</th>
                    <th style={{ textAlign: "center" }}>Case No</th>
                    <th>Customer Name</th>
                    <th style={{ textAlign: "center" }}>Provider Amount</th>
                  </>
                )}
                {searchFilter?.BusinessType === "IBU" && (
                  <>
                    <th className="payOutAdditionalTest">Provider Name</th>
                    <th>Insurer Name</th>
                    <th>Policy Ref No</th>
                    <th>Provider ID/Name</th>
                    <th>Provider Amount</th>
                  </>
                )}
                {header.map((ele) => {
                  return (
                    <th
                      className={`${
                        ele === "Additional Test" ||
                        ele === "Tests" ||
                        ele === "Test Details"
                          ? "financeAdditionalTest"
                          : "addHeader"
                      }`}
                    >
                      {ele}
                    </th>
                  );
                })}
              </tr>
            </thead>
            {payoutReducer?.getTotalAppointmentPayout?.length !== 0 && <tbody>
              {payoutReducer?.getTotalAppointmentPayout?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.providerName}</td>
                      <td style={{ minWidth: "200px" }}>{ele?.clientName}</td>
                      <td style={{ textAlign: "center" }}>
                        {searchFilter?.BusinessType === "CBU"
                          ? ele?.caseNo
                          : ele?.policyRefNo}
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.proposerName}</td>
                      <td className="addHeader">{ele?.providerAmount?.toLocaleString('en-IN')}</td>
                      {header.map((col) => {
                        return (
                          <td
                            className={`${
                              col === "Test Details"
                                ? "financeAdditionalTest"
                                : "addHeader"
                            }`}
                          >
                            {(col === "Test Details" && ele[payOutHeaderValue[col]] !== null)? (
                              <>
                                {showData === true && tableIndex === itemIndex
                                  ? ele[payOutHeaderValue[col]]
                                  : ele[payOutHeaderValue[col]]
                                      .split(" ")
                                      ?.slice(0, 10)
                                      ?.join(" ")}
                                <a
                                  id="payOutShowMoreBtn"
                                  onClick={() => {
                                    if (col === "Test Details") {
                                      // setShowData(!showData);
                                      setTableIndex(itemIndex);
                                      setShowData(
                                        showData && tableIndex === itemIndex
                                          ? false
                                          : true
                                      );
                                    }
                                  }}
                                >
                                  {ele[payOutHeaderValue[col]].split(" ")
                                    .length < 20
                                    ? ""
                                    : showData === true &&
                                      tableIndex === itemIndex
                                    ? " view less"
                                    : "...view more"}
                                </a>
                              </>
                            ) : col === "Appointment Closed Date" ? (
                              moment(ele?.appointmentClosedDate).format("ll")
                            ) : col === "Month" ? (
                              TotalProveiderMonth(ele?.year, ele?.month)
                            ) : (
                              ele[payOutHeaderValue[col]]
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                }
              )}
            </tbody>}
          </table>
          {payoutReducer?.getTotalAppointmentPayout?.length === 0 && (
        <p className="noRecordFound">No Record Found</p>
      ) }
          <div className="d-flex justify-content-center mt-4">
            {globalReducer?.getTotalCount !== 0 && (
              <CustomPagination
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilter?.rows}
                searchFilter={searchFilter}
                setSearchFilter={setSearchFilter}
                apiCall={GetAppointmentPayoutDetailsNetworkAction}
                IsPayoutStatus={false}
              />
            )}
          </div>
        </div>
    </>
  );
};
